export const VALIDATE_TOKEN_SURVEY_REQUEST = 'VALIDATE_TOKEN_SURVEY_REQUEST';
export const VALIDATE_TOKEN_SURVEY_SUCCESS = 'VALIDATE_TOKEN_SURVEY_SUCCESS';
export const VALIDATE_TOKEN_SURVEY_ERROR = 'VALIDATE_TOKEN_SURVEY_ERROR';

export const SAVE_SURVEY_REQUEST = 'SAVE_SURVEY_REQUEST';
export const SAVE_SURVEY_SUCESS = 'SAVE_SURVEY_SUCESS';
export const SAVE_SURVEY_ERROR = 'SAVE_SURVEY_ERROR';